export default __webpack_public_path__ + "static/media/refresh.c2c44d0f.svg";